import { NamedEntity } from '@shared';

export class Restaurant extends NamedEntity {
  parToken?: string;
  isVirtual: boolean;
  memberNo?: number;
  reportingUnit?: number;
  dmaName?: string;
  cityName?: string;
  conceptKey?: string;

  constructor(
    id: string,
    name: string,
    parToken?: string,
    isVirtual?: boolean,
    memberNo?: number,
    reportingUnit?: number,
    dmaName?: string,
    cityName?: string,
    conceptKey?: string,
  );
  constructor(restaurant: Restaurant);
  constructor(
    idOrRestaurant: string | Restaurant,
    name?: string,
    parToken?: string,
    isVirtual?: boolean,
    memberNo?: number,
    reportingUnit?: number,
    dmaName?: string,
    cityName?: string,
    conceptKey?: string,
  ) {
    if (typeof idOrRestaurant === 'string') {
      super(idOrRestaurant, name!);
      this.parToken = parToken;
      this.isVirtual = isVirtual || false;
      this.memberNo = memberNo;
      this.reportingUnit = reportingUnit;
      this.dmaName = dmaName;
      this.cityName = cityName;
      this.conceptKey = conceptKey;
    } else {
      super(idOrRestaurant.id, idOrRestaurant.name);
      this.parToken = idOrRestaurant.parToken;
      this.isVirtual = idOrRestaurant.isVirtual || false;
      this.memberNo = idOrRestaurant.memberNo;
      this.reportingUnit = idOrRestaurant.reportingUnit;
      this.dmaName = idOrRestaurant.dmaName;
      this.cityName = idOrRestaurant.cityName;
      this.conceptKey = idOrRestaurant.conceptKey;
    }
  }
}
